import { graphql } from '@/client/services/api/graphql/gql';

export const getUserAIConversationByIdQuery: any = graphql(`
  query GetUserAIConversation($id: String!) {
    getConversation(id: $id) {
      channel
      conversation
      createdAt
      id
      query
      references {
        contentId
        contentType
        contentTitle
        sourceType
        image
        link
        createdAt
        color
      }
      response
      sessionId
      threadId
    }
  }
`);
